<mat-card appearance="outlined">

    <mat-card-header>
        <mat-card-title>Status</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
    </mat-card-header>

    <mat-card-content class="h-96 overflow-auto">

        <p>Status content goes here...</p>

    </mat-card-content>

</mat-card>
